import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import ReactTooltip from 'react-tooltip';
import classNames from 'classnames';
import SnapshotViewer from './SnapshotViewer';
import SnapshotOutOfBoundsError from '../../../errors/SnapshotOutOfBoundsError';
import './styles.scss';

const propTypes = {
  currentItem: PropTypes.object,
  onSnapshotError: PropTypes.func.isRequired,
  onSnapshotReshoot: PropTypes.func.isRequired,
};

const defaultProps = {
  currentItem: {},
  onSnapshotError: () => {},
};

class LegacyTakeSnapshot extends React.Component {

  constructor(props) {
    super(props);
    this.reverse = this.reverse.bind(this);
    this.forward = this.forward.bind(this);
    this.reshoot = this.reshoot.bind(this);

    this.latency = 25; // This used to estimate the time differential between the Youtube feed and the actual livecam.
    this.maxRecursion = 256;

    // Pull this.props.snapshotMap out of props. It belongs in state.
    let { snapshotMap: availableSnapshots, currentItem, currentTimestamp, setCurrentSnapshot } = this.props;
    // Set the cursor to the newest snapshot
    // availableSnapshots.setCursor(availableSnapshots.lastKey());
    if (currentItem.stream_id) {
      availableSnapshots.setCursor(currentTimestamp);
    } else {
      availableSnapshots = this.rollbackNSeconds(this.latency, availableSnapshots);
    }

    this.state = {
      availableSnapshots,
      count: 0,
    };
  }

  componentWillMount() {
    const { setCurrentSnapshot } = this.props;
    const { availableSnapshots } = this.state;

    const { uri } = availableSnapshots.current();
    setCurrentSnapshot(uri);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { snapshotMap: availableSnapshots, currentItem, currentTimestamp, setCurrentSnapshot } = nextProps;
    const {  oldTimestamp } = this.props;

    if ( currentItem.stream_id && oldTimestamp !== currentTimestamp) {
      availableSnapshots.setCursor(currentTimestamp);
      const { uri } = availableSnapshots.current();
      setCurrentSnapshot(uri);
      this.setState({ availableSnapshots });
    }
  }

  forward(e) {
    if (e) { e.preventDefault(); }
    const { setCurrentSnapshot } = this.props;
    const { availableSnapshots } = this.state;

    const current = availableSnapshots.current();
    const next = availableSnapshots.nextOrLast();

    const { uri } = next;
    setCurrentSnapshot(uri);

    if (current.utcTimestamp !== next.utcTimestamp) {
      const count = this.state.count + 1;
      this.setState({ availableSnapshots, count });
    }
    // this.props.dispatch(adjustCount(next));
    // this.props.dispatch(setCurrentSnapshotIndex(this.props.timestampIndex + next));
  }
  reverse(e) {
    if (e) { e.preventDefault(); }
    const { setCurrentSnapshot } = this.props;
    const { availableSnapshots } = this.state;
    const current = availableSnapshots.current();
    const previous = availableSnapshots.previousOrFirst();
    const { uri } = previous;
    setCurrentSnapshot(uri);
    if (current.utcTimestamp !== previous.utcTimestamp) {
      const count = this.state.count - 1;
      this.setState({ availableSnapshots, count });
    }
  }

  rollbackNSeconds(n, availableSnapshots, attempts = 0) {
    const { currentItem } = this.props;
    const nSecondsAgo = Math.floor(Date.now() / 1000) - n;
    // exact match
    if (availableSnapshots.keys.indexOf(nSecondsAgo.toString()) > -1) {
      availableSnapshots.setCursor(nSecondsAgo.toString());
      return availableSnapshots;
    }

    if (availableSnapshots.keys[0] > nSecondsAgo) {
      availableSnapshots.setCursor(availableSnapshots.keys[0]);
      return availableSnapshots;
    }

    if (attempts >= this.maxRecursion) {
      if (currentItem.stream_id) {
        availableSnapshots.setCursor(availableSnapshots.keys[availableSnapshots.keys.length - 1]);
        return availableSnapshots;
      }
      // Don't throw the error because React 15.x.x will hijack the error not our try catch
      // https://medium.com/@leonardobrunolima/react-tips-error-handling-d6ca2171dd46
      // Just return false and we will handle where instantiated.
      this.props.onSnapshotError();
      return false;
    }
    return this.rollbackNSeconds(n - 1, availableSnapshots, attempts + 1);
  }

  reshoot() {
    const { onSnapshotReshoot, currentItem } = this.props;
    if (currentItem.stream_id) {
      onSnapshotReshoot(true);
    } else {
      let { availableSnapshots } = this.state;
      availableSnapshots = this.rollbackNSeconds(this.latency, availableSnapshots);
      this.setState({ availableSnapshots, count: 0 });
    }
  }

  captureSnapshot() {
    const { availableSnapshots } = this.state;
    return availableSnapshots.current().uri;
  }

  render() {
    const { currentItem, currentTimestamp } = this.props;
    const { count, availableSnapshots } = this.state;
    const { contests } = currentItem;
    let hasContest = false;
    if (contests) {
      hasContest = _.some(contests, (contest) => {
        return moment().isBefore(moment(contest.end_date));
      });
    }
    return (
      <div>
        <div className="info d-flex justify-content-center bg-fff">
          <ul className="d-flex justify-content-space align-items-center list-style-none pl-0 m-0 pY-10">
            <li>
              <Link
                to="#"
                onClick={this.reverse}
                className={classNames('snapshot-slide-btn left', { disabled: availableSnapshots.cursor === 0 })}
              >
                <i className="icon-ButtonArrowLeft" />
              </Link>
            </li>
            <li>
              <Link data-tip data-for="reshoot" onClick={this.reshoot} className="snapshot-btn d-flex justify-content-center align-items-center mX-40">
                <i className="icon-SnapshotCamera" />
              </Link>
              <ReactTooltip id="reshoot" type="light" effect="solid">reshoot</ReactTooltip>
            </li>
            <li>
              <Link to="#" onClick={this.forward} className="snapshot-slide-btn right"><i className="icon-ButtonArrowRight" /></Link>
            </li>
          </ul>
        </div>
        {hasContest && (
          <div className="alert alert-success mb-0 contest-alert">
            <div className="row align-items-center">
              <div className="col-auto pr-0">
                <i className="fa fa-trophy mr-2" />
              </div>
              <div className="col">
                This Livecam is currently part of a Snapshot Contest! Hit the trophy button to submit your best snapshots!
              </div>
            </div>
          </div>
        )}
        <SnapshotViewer
          recordingTemplate={currentItem.recordings_template}
          timestamp={currentTimestamp}
          count={count}
          snapshotData={availableSnapshots ? availableSnapshots.current() : new SnapshotOutOfBoundsError()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { timeline, timestampIndex, snapshotMap } = state.takeSnapshot;

  return {
    timestampIndex,
    currentTimestamp: timeline[timestampIndex],
    snapshotMap,
    currentItem: state.currentItem.data,
  };
};

LegacyTakeSnapshot.propTypes = propTypes;
LegacyTakeSnapshot.defaultProps = defaultProps;

export default connect(mapStateToProps, null, null, { withRef: true })(LegacyTakeSnapshot);
